import React from "react";

import Header from "../../components/header";
import Navbar from "../../components/navbar";
import AdPage from "../../components/AdPage";

export default function TermsOfUse() {
  return (
    <>
      <Header />
      <Navbar />

      <AdPage />
      <div className="flex justify-center">
        <section className="my-8 px-10 max-w-[1116px]">
          <h1 className="text-center my-5 font-bold text-3xl underline">
            プライバシーポリシー
          </h1>
          <br />
          Effective Date: 2025-05-27
          <br />
          <br />
          <span className="font-bold">はじめに</span>
          <br />
          <br />
          当ウェブサイトへようこそ。このプライバシーポリシーでは、当サイトを訪れたり、サイトとやり取りする際に、どのように情報を収集し、使用し、保護するかについて説明しています。当ウェブサイトを使用することで、このポリシーに記載された条項に同意することになります。
          <br />
          <br />
          <span className="font-bold">情報の収集と使用</span>
          <br />
          <br />
          当サイトでは、お問い合わせの際に自発的に提供された氏名、メールアドレス、またはその他の詳細など、特定の個人を特定できる情報（PII）を収集する場合があります。この情報は、あなたの体験を向上させたり、お問い合わせに対応したり、コミュニケーションの目的で使用するためのものであり、あなたの承諾なく個人情報を収集することはありません。
          <br />
          <br />
          <span className="font-bold">クッキー</span>
          <br />
          <br />
          当ウェブサイトでは、ユーザー体験を向上させるためにクッキーを使用します。クッキーは、デバイスに保存される小さなデータファイルで、ブラウザを識別し、サイトの機能を向上させるのに役立ちます。いつでもブラウザ設定を通じてクッキーを無効にできます。クッキーを無効にすると、サイトの一部の機能が制限される場合があります。
          <br />
          <br />
          <span className="font-bold">第三者サービス</span>
          <br />
          <br />
          当サイトの機能を向上させるために、第三者のサービスを使用する場合があります。例えば：
          <br />
          <br />
          <span className="flex items-center">
            <b className="mr-2 text-[6px]">●</b>
            Google Analytics (サイトのトラフィックを分析するため)
          </span>
          <span className="flex items-center">
            <b className="mr-2 text-[6px]">●</b>
            Google AdSense (関連する広告を提供するため)
          </span>
          <br />
          これらのサービスは、特定のデータを収集する場合がありますが、それぞれのプライバシーポリシーが適用されます。直接そのポリシーを確認してください。
          <br />
          <br />
          <span className="flex items-center">
            <b className="mr-2 text-[6px]">●</b>
            <a
              href="https://policies.google.com/privacy"
              className="text-blue-600 hover:underline"
            >
              Google Analytics プライバシーポリシー
            </a>
          </span>
          <span className="flex items-center">
            <b className="mr-2 text-[6px]">●</b>
            <a
              href="https://policies.google.com/technologies/ads"
              className="text-blue-600 hover:underline"
            >
              Google AdSense プライバシーポリシー
            </a>
          </span>
          <br />
          <span className="font-bold">データのセキュリティ</span>
          <br />
          <br />
          当サイトでは、あなたのデータを保護することを最優先事項としていますが、インターネット上の送信方法は完全に安全なものがないことを認識しています。商業的に受け入れられる手段を使用して情報を保護するよう努めていますが、絶対的な安全性を保証することはできません。
          <br />
          <br />
          <span className="font-bold">他のウェブサイトへのリンク</span>
          <br />
          <br />
          当サイトには、第三者のウェブサイトへのリンクが含まれる場合があります。当サイトは、外部サイトのプライバシー慣行やコンテンツについては責任を負いません。訪れるリンクサイトのプライバシーポリシーを確認することをお勧めします。
          <br />
          <br />
          <span className="font-bold">このプライバシーポリシーの変更</span>
          <br />
          <br />
          当サイトは、このポリシーを定期的に更新する場合があります。データをどのように保護しているかについて常に最新の情報を得るために、
          occasionalに確認することをお勧めします。当ウェブサイトの継続的な使用は、変更を承諾することを意味します。
          <br />
          <br />
          <span className="font-bold">お問い合わせ</span>
          <br />
          <br />
          このプライバシーポリシーに関する質問や懸念がある場合は、:{" "}
          <a
            href="mailto:KdNvS@example.com"
            className="text-blue-600 hover:underline"
          >
            info.PuffyGame@gmail.com
          </a>
          <br />
          <br />
        </section>
      </div>
    </>
  );
}
